export const DIALOG_TITLE_SX = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  pt: 2,
  pb: 1,
};

export const getDropzoneSx = (primaryColor: string, lightBackground: string) => ({
  alignItems: 'center',
  backgroundColor: lightBackground,
  borderColor: primaryColor,
  borderRadius: '10px',
  borderStyle: 'dashed',
  borderWidth: '1px',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  height: 240,
  justifyContent: 'center',
  p: 2,
  textAlign: 'center',
});
